import { Component, Input, Output, EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal, MzToastService } from "ng2-materialize";
import { Utils } from "../../utils/utils";
import { ProjectService } from "../../services/project/project.service";
import { Project } from "../../interfaces/project";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";

@Component({
  selector: "app-retrospective-wizard-2-invite",
  templateUrl: "./retrospective-wizard-2-invite.component.html",
  styleUrls: ["./retrospective-wizard-2-invite.component.scss"],
})
export class RetrospectiveWizardInviteComponent extends MzBaseModal {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @Input() project: Project;

  result: boolean;
  planningPokerLink: string;

  constructor(
    private projectService: ProjectService,
    private toastService: MzToastService,
    private planningPokerService: PlanningPokerService
  ) {
    super();
  }

  ngAfterViewInit() {}

  async show(): Promise<boolean> {
    this.planningPokerLink =
      this.env.agirUrl + "/planning-poker/" + this.project.shortId;
    this.result = undefined;
    this.modalComponent.open();
    await this.modalComponent.onClose
      .map((_) => true)
      .first()
      .toPromise();
    return this.result;
  }

  abort() {
    this.result = false;
    this.modalComponent.close();
  }

  confirm() {
    this.result = true;
    this.modalComponent.close();
  }

  toastCopyToClipboard() {
    this.toastService.show(
      "Link wurde in die Zwischenablage kopiert!",
      4000,
      "confirm-toast"
    );
  }

  async setEstimatePassword() {
    try {
      await this.projectService.setEstimatePassword(this.project);
      this.toastService.show("Passwort gespeichert!", 4000, "confirm-toast");
    } catch (error) {
      this.toastService.show(
        "Fehler! Nicht Gespeichert",
        4000,
        "notification-toast"
      );
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/retrospective-wizard-2-invite/retrospective-wizard-2-invite.component.ts